export default function(type) {
    switch (type) {
      case "phone":
        return "Llamada telefonica";
      default:
        return type;
    }
  }
  